import { EstadisticasList } from "src/general_components/EstadisticasList";


export const Estadisticas = () => {
   

    return (
        <>
            {/**********************************************************************
                🌟 Renderiza el componente genérico ABMGenerico para gestionar perfiles.
                - modelo: Identifica el modelo gestionado ("perfiles").
                - titulo: Título de la sección.
                - columnasAdicional: Columnas adicionales específicas de este modelo.
            **********************************************************************/}
            <EstadisticasList/>

          
        </>
    );
};
